// TODO 所有数学主动触达actouch相关页面路由在此配置
// TODO 所有数学主动触达actouch路由的path必须以 /actouch/ 开头
// TODO 所有路由的name以及webpackChunkName必须以 actouch 开头

export default [
  {
    path: '/actouch',
    redirect: { name: 'acTouch' }
  },
  {
    path: '/actouch/index',
    name: 'acTouch',
    component: () =>
      import(
        /* webpackChunkName: "acTouchInvite" */ '@/views/actouch/index.vue'
      ),
    meta: {
      title: 'VIPKID在线青少儿数学思维'
    }
  }
  // {
  //   path: '/actouch/success',
  //   name: 'actouchSuccess',
  //   component: () => import(/* webpackChunkName: "acTouchInvite" */ '@/views/actouch/success.vue'),
  //   meta: {
  //     title: 'VIPKID在线青少儿数学思维'
  //   }
  // },
  // {
  //   path: '/actouch/fail',
  //   name: 'actouchFail',
  //   component: () => import(/* webpackChunkName: "acTouchInvite" */ '@/views/actouch/fail.vue'),
  //   meta: {
  //     title: 'VIPKID在线青少儿数学思维'
  //   }
  // }
]
